import { Button, Col, DatePicker, Form, Row, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import React from "react";

interface IProps {
  formField: any;
  form: any;
  access: any;
  onReset: () => void;
  onSearch: () => void;
  openAddModal: () => void;
  openReportModal: () => void;
}


export const FilterReservoirsHistory = (props: IProps) => {
  const { t } = useTranslation();

  return (
	<Form form={ props.form } layout='vertical'>
	  <Row justify="space-between" align="middle" gutter={ 16 }>
		<Col span={ 12 }>
		  <Space.Compact>
			<Form.Item
			  label={ t('reservoir_history.date_start') }
			  name={ props.formField.dateForDayFrom }
			>
			  <DatePicker defaultValue={ null }/>
			</Form.Item>
			<Form.Item
			  label={ t('reservoir_history.date_end') }
			  name={ props.formField.dateForDayTo }
			>
			  <DatePicker defaultValue={ null }/>
			</Form.Item>
			<Button
			  type="primary"
			  shape="default"
			  size="middle"
			  style={ { marginLeft: 10, marginTop: 30 } }
			  icon={ <SearchOutlined/> }
			  onClick={ props.onSearch }
			>{ t('general.search') }</Button>
		  </Space.Compact>
		</Col>
		<Col span={ 12 } style={ { textAlign: 'right' } }>
		  { props.access && props.access.methodGet && (
			<Button type="primary" icon={ <PlusOutlined/> } style={ { marginRight: 10 } } onClick={ () => {
			  props.openReportModal()
			} }>
			  { t('general.generate_report') }
			</Button>
		  ) }
		  { props.access && props.access.methodPost && (
			<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
			  props.openAddModal()
			} }>
			  { t('general.add') }
			</Button>
		  ) }
		</Col>
	  </Row>
	</Form>
  )
}
